/**
 * Group (flat) array of objects by a particular object property
 * @param items source array of objects
 * @param property the property to group items by
 * @param fallback fallback value to group items by that don't have the specified property
 * @returns
 */
function groupBy(items, property, fallback) {
  const grouped = items.reduce((result, item) => {
    const key = property in item ? item[property] : fallback;
    const group = key in result ? result[key] : [];
    return Object.assign(Object.assign({}, result), {
      [key]: [...group, item]
    });
  }, {});
  return Object.entries(grouped);
}

export { groupBy };
//# sourceMappingURL=groupBy.js.map
